<template>
    <sidebar-container>
        <template v-slot:sidebar>
            <category-nav></category-nav>
        </template>
        <template v-slot:content>
            <carousel-main></carousel-main>
        </template>
    </sidebar-container>
</template>

<script>
    import SidebarContainer from '../Containers/SidebarContentContainer';
    import CategoryNav from '../Menu/CategoryNav';
    import CarouselMain from "../Carousel/CarouselMain";
    export default {
        name: "SidebarMain",
        components: { CategoryNav, CarouselMain, SidebarContainer }
    };
</script>

<style scoped>

</style>
